import dynamic from 'next/dynamic';
import React, { FC, ReactNode } from 'react';

const MediaQuery = dynamic(() => import('react-responsive'), {
  ssr: false,
});

const MaxScreen: FC<{ children: ReactNode }> = ({ children }) => {
  return <MediaQuery minWidth={1441}>{children}</MediaQuery>;
};

export default MaxScreen;
